import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { commonRoutes } from "../shared/commonRoutes";

export const RedirectToLogin = () => {

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname !== commonRoutes.login) {
            navigate(commonRoutes.login, { replace: true });
        }
    }, [location, navigate])

    return (
        <div>Redirecting...</div>
    )
}
